export const scrollIntoView = () => {
    const promotionsContainer = document.querySelector('#shop-promotions-container');
    if (promotionsContainer) {
        promotionsContainer.scrollIntoView();
    }
};
